import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { useStore } from '@thd-nucleus/experience-context';
import { StoreLocator } from './StoreLocator';

export const StoreLocatorContainer = () => {
  const { isCustomerIdentified = false } = useThdCustomer();
  const { storeId, isLocalized } = useStore({ varnish: false });
  const defaultVariables = {
    isBrandPricingPolicyCompliant: isLocalized ? isCustomerIdentified : false
  }
  return (
    <QueryProvider defaultVariables={defaultVariables} cacheKey="store-locator">
      <StoreLocator />
    </QueryProvider>
  );
};

StoreLocatorContainer.propTypes = {};

StoreLocatorContainer.defaultProps = {};
